<script setup lang="ts">
import MockupKitsPaginatedTable from "@/kits/components/KitsPaginatedTable.vue";

definePage({
  meta: {
    auth: ["Kits.Read"],
  },
});
</script>

<template>
  <MockupKitsPaginatedTable :is-archived="true" />
</template>
